const URL_RE = /(https?:\/\/[^\s]+)/g;

function Body({ text }) {
  return text.split("\n").map((line, i) => (
    <p key={i} className="min-h-[1.2em]">
      {line.split(URL_RE).map((part, j) => (URL_RE.test(part)
        ? <a key={j} href={part} target="_blank" rel="noopener noreferrer nofollow" className="break-all text-purple-300 underline decoration-purple-500/40 underline-offset-2 hover:text-purple-200">{part}</a>
        : part))}
    </p>
  ));
}

export const TrackNotes = ({ notes, slug }) => {
  if (!notes?.length) return null;
  return (
    <section className="mt-14 space-y-4" aria-labelledby="track-notes-heading" data-testid="track-notes">
      <h2 id="track-notes-heading" className="text-xs uppercase tracking-[0.3em] text-purple-400">Track notes · read before you publish</h2>
      {notes.map((n, i) => (
        <details key={n.title} open={i === 0} className="group border border-zinc-800 bg-[#0a0a0f]" data-testid={`track-note-${slug}-${i}`}>
          <summary className="cursor-pointer list-none px-6 py-4 font-display text-base font-black text-white marker:hidden group-open:border-b group-open:border-zinc-900 md:text-lg">{n.title}</summary>
          <div className="space-y-1 px-6 py-5 text-sm leading-relaxed text-zinc-300"><Body text={n.body} /></div>
        </details>
      ))}
    </section>
  );
};
